import { useQuery } from "@apollo/react-hooks";
import { useMemo } from "react";
import useRefetchOnFocus from "../../../../../hooks/useRefetchOnFocus";
import { GET_CONSULTORY_MONTHLY_CLOSURES } from "./queries";

export default function useActions({ dataDoctor, statusId, filterItem }) {
  const hasDoctorBranch = Boolean(
    dataDoctor?.medicalStaffId && dataDoctor?.branchOfficeId,
  );

  const {
    data: { getConsultoryMonthlyClosure } = {},
    loading,
    refetch,
  } = useQuery(GET_CONSULTORY_MONTHLY_CLOSURES, {
    skip: !hasDoctorBranch,
    fetchPolicy: "network-only",
    variables: {
      where: {
        medicalStaffId: dataDoctor?.medicalStaffId,
        branchOfficeId: dataDoctor?.branchOfficeId,
        ...(statusId ? { statusId } : {}),
      },
      relations: ["status"],
    },
  });

  useRefetchOnFocus(refetch, hasDoctorBranch);

  const data = useMemo(() => {
    const rows = getConsultoryMonthlyClosure || [];
    return filterItem ? rows.filter(filterItem) : rows;
  }, [getConsultoryMonthlyClosure, filterItem]);

  return [{ data, isLoading: loading }];
}
